import { Tag } from 'contentful'

export type TagParsed = {
  name: string
  id: string
}

export default function tagParser({ name, sys }: Tag): TagParsed {
  return {
    name,
    id: sys.id,
  }
}
